import { ProductScreen } from '../features/products/ProductScreen'
import { useShell } from '../app/outlet'

export function ProductPage() {
  const { toast } = useShell()
  return <ProductScreen onToast={toast} />
}
